import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
// import ListaUsuariosScreen from ".";
// import UsuarioScreen from "./usuario";
import ListarTipoUsuarioMovilPage from "./gestionar-tipo-usuario-movil/listar-tipo-usuario-movil";
import TipoUsuarioMovilPage from "./gestionar-tipo-usuario-movil/tipo-usuario-movil";
import ListarRolUsuarioWebPage from "./gestionar-rol-usuario-web/listar-rol-usuario-web";
import RolUsuarioWebPage from "./gestionar-rol-usuario-web/rol-usuario-web";
import ListarUsuariosMovilPage from "./gestionar-usuarios-movil/listar-usuarios-movil";
import UsuarioMovilPage from "./gestionar-usuarios-movil/usuario-movil";
import ListarUsuariosWebPage from "./gestionar-usuarios-web/listar-usuarios-web";
import UsuarioWebPage from "./gestionar-usuarios-web/usuario-web";
import PermisosPage from "./gestionar-rol-usuario-web/permisos-page";

const RouterUsuarios = () => {
  const { path } = useRouteMatch();
  return (
    // <LayoutChecklist>
    <Switch>

      {/* <Route exact path={`${path}`}>
        <ListarTipoUsuarioMovilPage />
      </Route> */}

      <Route exact path={`${path}/listar-tipo-usuario-movil`}>
        <ListarTipoUsuarioMovilPage />
      </Route>

      <Route exact path={`${path}/tipo-usuario-movil`}>
        <TipoUsuarioMovilPage />
      </Route>

      <Route exact path={`${path}/listar-rol-usuario-web`}>
        <ListarRolUsuarioWebPage />
      </Route>
      <Route exact path={`${path}/rol-usuario-web`}>
        <RolUsuarioWebPage />
      </Route>

      <Route exact path={`${path}/listar-usuarios-movil`}>
        <ListarUsuariosMovilPage />
      </Route>
      <Route exact path={`${path}/usuario-movil`}>
        <UsuarioMovilPage />
      </Route>

      <Route exact path={`${path}/listar-usuarios-web`}>
        <ListarUsuariosWebPage />
      </Route>
      <Route exact path={`${path}/usuario-web`}>
        <UsuarioWebPage />
      </Route>

      <Route exact path={`${path}/permisos-page`}>
        <PermisosPage />
      </Route>

    </Switch>

  );
};

export default RouterUsuarios;
